import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ReviewerComments = () => {
  const platformId = localStorage.getItem('platformID');
  const [authors, setAuthors] = useState([]);
  const [selectedAuthorId, setSelectedAuthorId] = useState('');
  const [submissions, setSubmissions] = useState([]);
  const [selectedSubmissionId, setSelectedSubmissionId] = useState('');
  const [reviews, setReviews] = useState([]);
  const [selectedReviewIds, setSelectedReviewIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const API = process.env.REACT_APP_API_BASE_URL;
  

  useEffect(() => {
    if (platformId) {
      axios.get(`${API}/api/reviewer-comments/authors/${platformId}`)
        .then(res => setAuthors(res.data))
        .catch(err => console.error(err));
    }
  }, [platformId]);

  useEffect(() => {
    if (selectedAuthorId) {
      axios.get(`${API}/api/reviewer-comments/submissions/${selectedAuthorId}/${platformId}`)
        .then(res => setSubmissions(res.data))
        .catch(err => console.error(err));
    }
  }, [selectedAuthorId]);

  useEffect(() => {
    if (selectedSubmissionId) {
      axios.get(`${API}/api/reviewer-comments/reviews/${selectedAuthorId}/${selectedSubmissionId}/${platformId}`)
        .then(res => setReviews(res.data))
        .catch(err => console.error(err));
    }
  }, [selectedSubmissionId]);

  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    setSelectedReviewIds(e.target.checked ? reviews.map(r => r.Srid) : []);
  };

  const handleCheckboxChange = (id) => {
    if (selectedReviewIds.includes(id)) {
      setSelectedReviewIds(selectedReviewIds.filter(srid => srid !== id));
    } else {
      setSelectedReviewIds([...selectedReviewIds, id]);
    }
  };

  const handleShareReviews = async () => {
    if (selectedReviewIds.length === 0) {
        alert('Please select at least one review to share.');
        return;
    }
    if (!selectedSubmissionId) {
        alert('Please select a submission first.');
        return;
    }
    try {
      await axios.post(`${API}/api/reviewer-comments/share`, {
          sridList: selectedReviewIds,
          submissionID: selectedSubmissionId
      });
      alert('Selected reviews shared successfully!');
      
      const res = await axios.get(`${API}/api/reviewer-comments/reviews/${selectedAuthorId}/${selectedSubmissionId}/${platformId}`);
      setReviews(res.data);
      setSelectedReviewIds([]);
      setSelectAll(false);
    } catch (error) {
      console.error(error);
    }
};

  const handleAcceptOrResubmit = async (status) => {
    if (!selectedSubmissionId) return;
    try {
      await axios.put(`${API}/api/reviewer-comments/update-status`, {
        submissionID: selectedSubmissionId,
        Status: status
      });
      alert(`Submission marked as ${status}`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container my-4 ml-2">
      <h3 className="page-title mb-4">Reviewer Comments Management</h3>
      {/* Author Dropdown */}
      <div className="mb-3">
        <label>Select Author</label>
        <select className="form-select" value={selectedAuthorId} onChange={(e) => setSelectedAuthorId(e.target.value)}>
          <option value="">-- Select Author --</option>
          {authors.map(author => (
            <option key={author.AuthorID} value={author.AuthorID}>{author.AuthorName}</option>
          ))}
        </select>
      </div>

      {/* Submissions Dropdown */}
      {submissions.length > 0 && (
        <div className="mb-3">
          <label>Select Submission</label>
          <select className="form-select" value={selectedSubmissionId} onChange={(e) => setSelectedSubmissionId(e.target.value)}>
            <option value="">-- Select Submission --</option>
            {submissions.map(sub => (
              <option key={sub.submissionID} value={sub.submissionID}>{sub.SubmissionTitle}</option>
            ))}
          </select>
        </div>
      )}

      {/* Reviews Table */}
      {reviews.length > 0 && (
        <div className="mt-3">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th><input type="checkbox" checked={selectAll} onChange={handleSelectAll} /></th>
                <th>Reviewer</th>
                <th>Decision</th>
                <th>Review Date</th>
              </tr>
            </thead>
            <tbody>
              {reviews.map(review => (
                <tr key={review.Srid} title={review.Comment}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedReviewIds.includes(review.Srid)}
                      onChange={() => handleCheckboxChange(review.Srid)}
                    />
                  </td>
                  <td>{review.ReviewerName}</td>
                  <td>{review.Decision}</td>
                  <td>{new Date(review.ReviewDate).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="mt-3">
            <button className="btn btn-primary me-2" onClick={handleShareReviews}>Share Selected Reviews</button>
            <button className="btn btn-success me-2" onClick={() => handleAcceptOrResubmit('Accept')} hidden>Accept</button>
            <button className="btn btn-warning" onClick={() => handleAcceptOrResubmit('Pending')} hidden>Resubmit</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewerComments;
